 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9":"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9","about":"about","blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a":"blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a","blog-index":"blog-index","checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca":"checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca","checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57":"checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57","checkout":"checkout","directory":"directory","event":"event","main-admin-certificates":"main-admin-certificates","main-admin-events-detail":"main-admin-events-detail","main-admin-products":"main-admin-products","main-admin-users-create":"main-admin-users-create","main-admin-users-edit":"main-admin-users-edit","main-profile-edit":"main-profile-edit","recertify-checkout":"recertify-checkout","sign-up":"sign-up","main-dashboard~my-courses~purchase-history":"main-dashboard~my-courses~purchase-history","main-dashboard":"main-dashboard","my-courses":"my-courses","purchase-history":"purchase-history","main-profile-password~materials-checkout~recover-password~reset-password":"main-profile-password~materials-checkout~recover-password~reset-password","main-profile-password":"main-profile-password","recover-password":"recover-password","reset-password":"reset-password","resources":"resources","blog-page":"blog-page","checkout-success":"checkout-success","confirm":"confirm","events":"events","home~mdtp":"home~mdtp","mdtp":"mdtp","main-profile":"main-profile","materials-checkout":"materials-checkout","main-admin-change-requests~main-admin-events~main-admin-users":"main-admin-change-requests~main-admin-events~main-admin-users","main-admin-change-requests":"main-admin-change-requests","main-admin-events":"main-admin-events","main-admin-users":"main-admin-users","host-seminar":"host-seminar","login":"login","main~public":"main~public","main":"main","public":"public","evidence":"evidence","giselle-carnaby":"giselle-carnaby","home":"home","instructor-disclosures":"instructor-disclosures","main-admin":"main-admin","main-admin-reports":"main-admin-reports","michael-crary":"michael-crary","privacy-policy":"privacy-policy","refund-policy":"refund-policy","start":"start","terms":"terms"}[chunkId]||chunkId) + "." + {"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9":"f5bf5b8e","about":"eaca426c","blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a":"d76acc40","blog-index":"a2c2fd26","checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca":"94de6fae","checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57":"4a0a6af6","checkout":"f7ac7de4","directory":"27c8a7e5","event":"2be77e38","main-admin-certificates":"4e7dbb51","main-admin-events-detail":"cc5f9000","main-admin-products":"34e55eb9","main-admin-users-create":"6b610990","main-admin-users-edit":"f588e8b5","main-profile-edit":"5d6811d7","recertify-checkout":"c0e13308","sign-up":"12363904","main-dashboard~my-courses~purchase-history":"3a0952c4","main-dashboard":"8ac3bab2","my-courses":"4f31fb15","purchase-history":"399ac023","main-profile-password~materials-checkout~recover-password~reset-password":"db8e8ad6","main-profile-password":"0f7c2a73","recover-password":"4cd50d80","reset-password":"f6add756","resources":"3d72507e","blog-page":"a60cdeaa","checkout-success":"d1c679fa","confirm":"17871c68","events":"3bfea38a","home~mdtp":"9fb90d3b","mdtp":"ba451a83","main-profile":"dc2e6112","materials-checkout":"85a538a1","main-admin-change-requests~main-admin-events~main-admin-users":"38db9b35","main-admin-change-requests":"dc7bc652","main-admin-events":"be9d879e","main-admin-users":"4ee1536d","host-seminar":"9859429d","login":"fffaf09b","main~public":"63ea0b82","main":"5bab9d7d","public":"3a1848d4","evidence":"f8b7a3a8","giselle-carnaby":"37264099","home":"fd01f0b3","instructor-disclosures":"9b2645e2","main-admin":"a1d30d23","main-admin-reports":"04e69483","michael-crary":"989c5dfc","privacy-policy":"2548d57b","refund-policy":"6d79d931","start":"a4675c8a","terms":"c6958974"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9":1,"about":1,"blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a":1,"blog-index":1,"checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca":1,"checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57":1,"checkout":1,"main-admin-certificates":1,"main-admin-events-detail":1,"main-admin-products":1,"main-admin-users-edit":1,"main-profile-edit":1,"recertify-checkout":1,"sign-up":1,"main-dashboard~my-courses~purchase-history":1,"main-dashboard":1,"recover-password":1,"reset-password":1,"resources":1,"blog-page":1,"events":1,"home~mdtp":1,"mdtp":1,"materials-checkout":1,"main-admin-change-requests~main-admin-events~main-admin-users":1,"main-admin-change-requests":1,"main-admin-events":1,"main-admin-users":1,"host-seminar":1,"login":1,"main~public":1,"main":1,"public":1,"home":1,"main-admin-reports":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9":"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9","about":"about","blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a":"blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a","blog-index":"blog-index","checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca":"checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca","checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57":"checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57","checkout":"checkout","directory":"directory","event":"event","main-admin-certificates":"main-admin-certificates","main-admin-events-detail":"main-admin-events-detail","main-admin-products":"main-admin-products","main-admin-users-create":"main-admin-users-create","main-admin-users-edit":"main-admin-users-edit","main-profile-edit":"main-profile-edit","recertify-checkout":"recertify-checkout","sign-up":"sign-up","main-dashboard~my-courses~purchase-history":"main-dashboard~my-courses~purchase-history","main-dashboard":"main-dashboard","my-courses":"my-courses","purchase-history":"purchase-history","main-profile-password~materials-checkout~recover-password~reset-password":"main-profile-password~materials-checkout~recover-password~reset-password","main-profile-password":"main-profile-password","recover-password":"recover-password","reset-password":"reset-password","resources":"resources","blog-page":"blog-page","checkout-success":"checkout-success","confirm":"confirm","events":"events","home~mdtp":"home~mdtp","mdtp":"mdtp","main-profile":"main-profile","materials-checkout":"materials-checkout","main-admin-change-requests~main-admin-events~main-admin-users":"main-admin-change-requests~main-admin-events~main-admin-users","main-admin-change-requests":"main-admin-change-requests","main-admin-events":"main-admin-events","main-admin-users":"main-admin-users","host-seminar":"host-seminar","login":"login","main~public":"main~public","main":"main","public":"public","evidence":"evidence","giselle-carnaby":"giselle-carnaby","home":"home","instructor-disclosures":"instructor-disclosures","main-admin":"main-admin","main-admin-reports":"main-admin-reports","michael-crary":"michael-crary","privacy-policy":"privacy-policy","refund-policy":"refund-policy","start":"start","terms":"terms"}[chunkId]||chunkId) + "." + {"about~blog-index~blog-page~checkout~checkout-success~confirm~directory~event~events~main-admin-certi~9563f0e9":"2ef5cab2","about":"d02844a9","blog-index~checkout~directory~event~host-seminar~login~main-admin-certificates~main-admin-change-req~dfb97a9a":"3efb7f07","blog-index":"4b7d9b7c","checkout~directory~event~main~main-admin-certificates~main-admin-change-requests~main-admin-events~m~372278ca":"4a1d354e","checkout~directory~event~main-admin-certificates~main-admin-change-requests~main-admin-events~main-a~dc341c57":"c536731c","checkout":"dc90bde3","directory":"31d6cfe0","event":"31d6cfe0","main-admin-certificates":"a5e3fae2","main-admin-events-detail":"c1809e9f","main-admin-products":"8f3e268e","main-admin-users-create":"31d6cfe0","main-admin-users-edit":"15c2dc65","main-profile-edit":"b1c5e618","recertify-checkout":"1a277322","sign-up":"e64760cb","main-dashboard~my-courses~purchase-history":"d02844a9","main-dashboard":"5ec5f71e","my-courses":"31d6cfe0","purchase-history":"31d6cfe0","main-profile-password~materials-checkout~recover-password~reset-password":"31d6cfe0","main-profile-password":"31d6cfe0","recover-password":"49c25a45","reset-password":"49c25a45","resources":"13e27461","blog-page":"4b04fbb6","checkout-success":"31d6cfe0","confirm":"31d6cfe0","events":"35621aad","home~mdtp":"6943ca51","mdtp":"78017a8d","main-profile":"31d6cfe0","materials-checkout":"1a277322","main-admin-change-requests~main-admin-events~main-admin-users":"0eb141b7","main-admin-change-requests":"83018a79","main-admin-events":"2b308121","main-admin-users":"2b308121","host-seminar":"2b308121","login":"4f03cf8b","main~public":"0a750cd2","main":"52338f23","public":"69629c52","evidence":"31d6cfe0","giselle-carnaby":"31d6cfe0","home":"2ef5cab2","instructor-disclosures":"31d6cfe0","main-admin":"31d6cfe0","main-admin-reports":"67dd955d","michael-crary":"31d6cfe0","privacy-policy":"31d6cfe0","refund-policy":"31d6cfe0","start":"31d6cfe0","terms":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
